/** 25 pastel hex colors for OperationProcessStep selection. */
export const PASTEL_COLORS = [
  "#FFCDD2", // soft red
  "#F8BBD0", // soft pink
  "#E1BEE7", // soft purple
  "#D1C4E9", // soft deep purple
  "#C5CAE9", // soft indigo
  "#BBDEFB", // soft blue
  "#B3E5FC", // soft light blue
  "#B2EBF2", // soft cyan
  "#B2DFDB", // soft teal
  "#C8E6C9", // soft green
  "#DCEDC8", // soft light green
  "#F0F4C3", // soft lime
  "#FFF9C4", // soft yellow
  "#FFECB3", // soft amber
  "#FFE0B2", // soft orange
  "#FFCCBC", // soft deep orange
  "#D7CCC8", // soft brown
  "#CFD8DC", // soft blue grey
  "#F5F5F5", // soft grey
  "#FFCCCB", // light coral
  "#E6E6FA", // lavender
  "#FFE4E1", // misty rose
  "#E0F7FA", // pale cyan
  "#E8F5E9", // pale green
  "#FFF3E0", // pale peach
];

export const DEFAULT_PASTEL_COLOR = PASTEL_COLORS[0];
